'use strict';

/**
 * True when Portal `ProjectDescription.pipeline` is Core (Lab Vantage / non-mlims V7).
 * Matches PortalApi `Metabolon.Portal.Common.Types.Pipeline` and migration from ProjectSource type `core`.
 *
 * @param {unknown} projectPipeline
 * @returns {boolean}
 */
export function isLabVantageCoreProject(projectPipeline) {
	return String(projectPipeline ?? '').trim().toLowerCase() === 'core';
}
